module.exports = __webpack_public_path__ + "img/Button_KasPro.80e46625.png";